import ScheduleCard from "./ScheduleCard";

export default function ScheduleSidebar({
  asapItems = [],
  urgentItems = [],
  lang,
  onCardClick,
}) {
  return (
    <div className="schedule-sidebar">
      <div className="sidebar-section urgent">
        <h4>{lang === "ar" ? "عاجل" : "Urgent"}</h4>

        {urgentItems.length > 0 ? (
          urgentItems.map((item) => (
            <ScheduleCard
              key={item._id}
              item={item}
              lang={lang}
              onClick={() => onCardClick(item)}
            />
          ))
        ) : (
          <p className="empty-text">{lang === "ar" ? "لا يوجد" : "No items"}</p>
        )}
      </div>

      <div className="sidebar-section asap">
        <h4>{lang === "ar" ? "في أقرب وقت" : "ASAP"}</h4>

        {asapItems.length > 0 ? (
          asapItems.map((item) => (
            <ScheduleCard
              key={item._id}
              item={item}
              lang={lang}
              onClick={() => onCardClick(item)}
            />
          ))
        ) : (
          <p className="empty-text">{lang === "ar" ? "لا يوجد" : "No items"}</p>
        )}
      </div>
    </div>
  );
}